import { render, staticRenderFns } from "./index.vue?vue&type=template&id=bca47a6a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=bca47a6a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca47a6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("K:\\website\\tmp\\2021.7-12\\mmlzcyy_project\\screen\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bca47a6a')) {
      api.createRecord('bca47a6a', component.options)
    } else {
      api.reload('bca47a6a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=bca47a6a&scoped=true&", function () {
      api.rerender('bca47a6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/granary/page/index.vue"
export default component.exports